import React from 'react';

import { shortcutType } from 'types';

import {
  StyledIcon,
  StyledContainer,
  StyledLabel,
  StyledValue,
} from './styled';

const Shortcut = ({ shortcut }) => (
  <StyledContainer>
    <StyledLabel>{shortcut.name}</StyledLabel>

    {shortcut.iconClass ? (
      <StyledIcon className={shortcut.iconClass} data-test="shortcut-icon" />
    ) : (
      <StyledValue data-test="shortcut-value">
        {shortcut.combination}
      </StyledValue>
    )}
  </StyledContainer>
);

Shortcut.propTypes = {
  shortcut: shortcutType,
};

export default Shortcut;
